import React, { useState, useEffect } from 'react';
import './LoadingState.css';

const steps = [
  'Yapay zeka analiz ediyor...',
  'CV ve tercihler değerlendiriliyor...',
  'Uygun pozisyonlar taranıyor...',
  'Sonuçlar sıralanıyor...',
];

const LoadingState = () => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prev) => (prev < steps.length - 1 ? prev + 1 : prev));
    }, 700);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-state">
      <div className="loading-state__bar">
        <div className="loading-state__bar-fill"></div>
      </div>
      <div className="loading-state__steps">
        {steps.map((step, i) => (
          <div
            key={i}
            className={`loading-state__step ${i <= currentStep ? 'loading-state__step--active' : ''} ${i === currentStep ? 'loading-state__step--current' : ''}`}
          >
            <div className="loading-state__dot"></div>
            <span>{step}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingState;
